import SimplePage from "../components/site/SimplePage";

const sections = [
  {
    title: "Ongoing Projects",
    text: "Programs currently active across our regions with a focus on long-term community support.",
    items: ["Rural STEM learning hubs", "Mobile health units", "Women-led cooperatives"]
  },
  {
    title: "Completed Projects",
    text: "Initiatives that have achieved their goals and transitioned to local ownership.",
    items: ["Clean water access for 12 villages", "School retention drive", "Nutrition awareness program"]
  }
];

function Projects() {
  return (
    <SimplePage
      title="Projects"
      lead="Each project is designed with community leaders and measured through transparent reporting."
      sections={sections}
    />
  );
}

export default Projects;
